import * as React from "react"
import { Link }   from "react-router-dom"
import {
	FooterItem,
	isLinkFooterItem,
	isButtonFooterItem,
} from "./footer-item"

export default class Card
extends React.Component<CardProps> {
	render() {
		const children    = this.props.children
		const footerItems = this.props.footerItems
		const icon        = this.props.icon
		const loading     = this.props.loading
		const paddingless = this.props.paddingless
		const onIconClick = this.props.onIconClick
		const title       = this.props.title

		return <div className={`card ${this.props.className || ""}`}>
			{(title || icon) &&
			<header className="card-header">
				{title &&
					<h2 className="card-header-title">
						{loading &&
							<span className="icon">
								<i className="fas fa-spinner fa-pulse" />
							</span>}
						{title}
					</h2>}
				{icon &&
				<a className="card-header-icon" onClick={onIconClick}>
					<span className="icon"><i className={`fas ${icon}`}></i></span>
				</a>}
			</header>}

			<main className={`card-content ${paddingless ? "is-paddingless" : ""}`}>
				<div className="content" children={children} />
			</main>

			{(footerItems && footerItems.length) &&
			<footer className="card-footer">
				{footerItems.map((item, index) => {
					if (isLinkFooterItem(item))
						return (
							loading || item.disabled
							? <p className="card-footer-item" key={index}>{item.content}</p>
							: <Link className="card-footer-item" key={index} title={item.title} to={item.to}>
									{item.content}
								</Link>
						)

					if (isButtonFooterItem(item))
						return (
							loading || item.disabled
							? <p className="card-footer-item" key={index}>{item.content}</p>
							: <a className="card-footer-item" key={index} onClick={item.onClick} title={item.title}>
									{item.content}
								</a>
						)

					return <p className="card-footer-item" key={index}>{item.content}</p>
				})}
			</footer>}
		</div>
	}
}

export interface CardProps {
	className?  : string
	footerItems?: FooterItem[]
	icon?       : string
	loading?    : boolean
	paddingless?: boolean
	title?      : string
	onIconClick?(event: React.SyntheticEvent<Element>): void
}



// WEBPACK FOOTER //
// ./src/component/card/index.tsx